import defaultLandscapePicture from '../../../assets/img/default-landscape.svg';
import { ProjectInvitationDto } from '../../../api';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import styles from './InvitationTile.module.less';
import { AppDispatch } from '../../../redux/store';
import { useDispatch } from 'react-redux';
import { acceptInvitation, declineInvitation } from '../../../redux/reducers/collaboratorSlice';
import OmniNotification from '../../OmniNotification';

type Props = {
	invitation: ProjectInvitationDto
	callback: Function
}

export default function InvitationTile(props: Props) {
	const { invitation, callback } = props;
	const { t } = useTranslation();
	const dispatch: AppDispatch = useDispatch();

	const handleDecline = async () => {
		const result = await dispatch(declineInvitation(invitation.invitationId));

		if (!declineInvitation.fulfilled.match(result)) {
			OmniNotification.error({
				message: t('notification.error.title'),
				description: result.error.message || t('api.defaultError'),
			});
			return;
		}
		callback();
	};

	const handleAccept = async () => {
		const result = await dispatch(acceptInvitation(invitation.invitationId));

		if (!acceptInvitation.fulfilled.match(result)) {
			OmniNotification.error({
				message: t('notification.error.title'),
				description: result.error.message || t('api.defaultError'),
			});
			return;
		}
		callback();
	};

	return (
		<div data-testid="invitation_tile" className={styles.invitatonTile}>
			<div className={styles.image}>
				<img src={defaultLandscapePicture} />
			</div>

			<div>
				<div className={styles.labels}>
					<h2 data-testid="testProjectName">{invitation.projectName}</h2>
					<span data-testid="testInviterName">{t('ProjectPage.Invitation.Body', { inviter_name: invitation.inviterName })}</span>
				</div>
				<div className={styles.buttons}>
					<Button type="primary" className={styles.declineButton}
					        onClick={handleDecline}>{t('ProjectPage.Invitation.Decline')}</Button>
					<Button type="primary" onClick={handleAccept}>{t('ProjectPage.Invitation.Accept')}</Button>
				</div>
			</div>
		</div>

	);

}